import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    sortList: { type: Array, default: [[0, 0]] },
    widgets: { type: Array, default: ["zebra"] }
  }

  connect() {
    if (!window.jQuery) return

    window.$(this.element).tablesorter({
      sortList: this.sortListValue,
      widgets: this.widgetsValue
    })
  }
}
